module.exports = __webpack_public_path__ + "static/media/react.4603f0d1.png";